import $ from "jquery";
import * as hb from "handlebars";
import { Helpers } from "./handlebars-helpers";
import { Results, URLCriteriaHelper } from "./data";
import { Params } from "./data-structures";
import { API } from "./api";
import { GlobalVariables, GlobalFunctions as gf } from "./data";
import { Events } from "./search-events";
import { DataConversion } from "./data-conversion";
import { GetAlertsWithHandlebars } from "../Alerts/Alerts";
declare var LoadingSessionPreferences: any;
declare var IsSessionLoaded: any;
declare var brandedSearch: any;

var myParams: Params = GlobalVariables.getParams();
if (myParams.Keyword) {
    var temp = decodeURIComponent(myParams.Keyword.replace(/\+/g, '%20'));
    var keyword = gf.padKeyword(temp);
    if (temp !== keyword) {
        myParams.Keyword = keyword;
    }
    (<HTMLInputElement>document.getElementById("nav-keyword")).value = keyword;
}
new Helpers().registerHelpers();
new Events().setupEvents();

var templates: { [id: string]: HandlebarsTemplateDelegate; } = {};
$(document).ready(function () {
    templates["jobCountTemplateHtml"] = require("../../../Search/Templates/search_job_count.handlebars");
    templates["filterCountTemplateHtml"] = require("../../../Search/Templates/search_filter_count.handlebars");
    templates["sortTemplateHtml"] = require("../../../Search/Templates/search_sort.handlebars");
    templates["sortMobileTemplateHtml"] = require("../../../Search/Templates/search_sort_mobile.handlebars");
    templates["jobCardTemplateHtml"] = require("../../../Search/Templates/search_result_card.handlebars");
    templates["noResultsTemplateHtml"] = require("../../../Search/Templates/search_no_results.handlebars");
    templates["pagerTemplateHtml"] = require("../../../Search/Templates/search_page.handlebars");
    templates["profilePreferencesNotSignedIn"] = require("../../../Search/Templates/search_profile_preferences_signed_out.handlebars");
    templates["profilePreferencesSignedIn"] = require("../../../Search/Templates/search_profile_preferences_signed_in.handlebars");
    templates["departmentTemplateHtml"] = require("../../../Search/Templates/search_department.handlebars");
    templates["agencyTemplateHtml"] = require("../../../Search/Templates/search_agency.handlebars");
    templates["locationTemplateHtml"] = require("../../../Search/Templates/search_count.handlebars");
    templates["filterPillHtml"] = require("../../../Search/Templates/search_filter_pill.handlebars");
    templates["filterGroupHtml"] = require("../../../Search/Templates/search_filter_groups.handlebars");
    templates["filterItemHtml"] = require("../../../Search/Templates/search_filter_items.handlebars");
    templates["location"] = require("../../../Search/Templates/search_count.handlebars");
    templates["seriesJumpToTemplateHtml"] = require("../../../Search/Templates/search_series_jump.handlebars");
    templates["seriesFilterTemplateHtml"] = require("../../../Search/Templates/search_series_filter.handlebars");
    templates["savedSearchNonSignedIn"] = require("../../../Search/Templates/search_saved_search_signed_out.handlebars");
    templates["savedSearchSignedIn"] = require("../../../Search/Templates/search_saved_search_signed_in.handlebars");
    templates["searchterms"] = require("../../../Search/Templates/search_no_results_searchterms.handlebars");
    templates["suggestions"] = require("../../../Search/Templates/search_suggestions.handlebars");
    templates["teaser-privacy-template"] = require("../../../Search/Templates/search_teaser_privacy.handlebars");
    templates["teaser-cyber-security-template"] = require("../../../Search/Templates/search_teaser_cyber_security.handlebars");
    templates["teaser-data-science-template"] = require("../../../Search/Templates/search_teaser_data_science.handlebars");
    GetAlertsWithHandlebars("SearchResultsAlert", "Search");
});

GlobalVariables.setTemplates(templates);

/* session-loaded is fired from usajobs-storage after building the user object */
document.addEventListener('session-loaded', search_sessionLoaded);

function search_sessionLoaded() {
    // this function should only be called once per session-load.
    document.removeEventListener('session-loaded', search_sessionLoaded);
    if (!brandedSearch) {
        gf.checkCandidateEligibility();
    }
    myParams = gf.convertSeriesFamilyToSeries(myParams);
    if (myParams.SavedSearchID) {
        var savedSearchID = !myParams.SavedSearchID ? 0 : myParams.SavedSearchID;
        var storedSearchPromise = API.current.GetStoredResults(savedSearchID);
        gf.displayInitialStored(storedSearchPromise, GlobalVariables.getTemplates());
    }
    else {
        var searchPromise = API.current.GetResults(myParams);
        gf.displayInitialLoad(searchPromise, GlobalVariables.getTemplates());
    }
}
